import { INKLE_WEBSITE_URL } from "./base";

export const PAYMENT_METHOD = [
  {
    name: "FedWire",
    key: "12",
    required: "Routing Number",
  },
  {
    name: "ACH Credit",
    key: "13",
    required: "Routing Number",
  },
  {
    name: "RTP",
    key: "14",
    required: "Routing Number",
  },
  { name: "SWIFT", key: 15, required: "BIC" },
];

export const ROUTING_NUMBER = "Routing Number";
export const ABA_CODE = "ABA Code/Routing Number";
export const BIC = "BIC";

export const SUPPORT_TP_CALENDLY_LINK =
  "https://calendly.com/inklehq/inkle-transfer-pricing-demo-onboarding";

export const TP_COMPLIANCE_CALENDLY_LINK =
  "https://calendly.com/arjav-inkle/transfer-pricing-compliances";
export const SWIFT_BLOG_LINK = `${INKLE_WEBSITE_URL}core-products/tp-payments#comparison`;
export const SQUAREFEET_BLOG_LINK = `${INKLE_WEBSITE_URL}case-studies/91squarefeet`;
